import { ICommand } from 'core-ts-types';
export function MyTodoRoutes($stateProvider: any) {
  // todos route
  $stateProvider
    .state('my.todos', {
      url: 'todos/:filterBy/',
      templateUrl: 'lib/my_todos/views/my_todos/my_todos.html',
      controller: 'MyTodosController',
      controllerAs: '$ctrl',
      params: {
        filterBy: {
          value: 'all'
        }
      },
      sticky: true,
      data: {
        viewTitle: 'To-Dos and Events',
        hasMainMenu: true
      }
    })

    // todos details route
    .state('my.todos.details', {
      url: 'details/:eventId/:repeatedBy',
      views: {
        '@my': {
          templateUrl: 'lib/my_todos/views/my_todos_detail/my_todos_detail.html',
          controller: 'MyTodosDetailController',
          controllerAs: '$ctrl'
        }
      },
      data: {
        viewTitle: 'To-Do Detail',
        suppressTrackingPage: true
      },
      params: {
        topic: undefined
      },
      resolve: {
        pathTaskDetail: (
          loadPathItemCommand: ICommand,
          $stateParams: ng.ui.IStateParamsService,
          $state: ng.ui.IStateService
        ) => loadPathItemCommand($stateParams.eventId, $stateParams.repeatedBy)
      }
    })
    // Appointment details route
    .state('my.todos.appointment', {
      url: 'appointment/:eventId/:repeatedBy',
      views: {
        '@my': {
          templateUrl: 'lib/my_todos/views/my_todos_appointment_details/my_todos_appointment_details.html',
          controller: 'MyTodosAppointmentDetailsController',
          controllerAs: '$ctrl'
        }
      },
      data: {
        viewTitle: 'Appointment Details'
      },
      resolve: {
        previousState: ($state: ng.ui.IStateService) => ({ state: $state.current.name, params: $state.params }),
        pathTaskDetail: (
          loadPathItemCommand: ICommand,
          $stateParams: ng.ui.IStateParamsService,
          $state: ng.ui.IStateService
        ) => loadPathItemCommand($stateParams.eventId, $stateParams.repeatedBy),
        appointmentDetails: (
          $state: ng.ui.IStateService,
          $stateParams: ng.ui.IStateParamsService,
          loadAppointmentDetailsCommand: ICommand
        ) => loadAppointmentDetailsCommand($stateParams.eventId, $stateParams.repeatedBy)
      }
    })

    // Appointment request details route
    .state('my.todos.appointmentRequest', {
      url: 'appointment_request/:eventId/:repeatedBy',
      views: {
        '@my': {
          templateUrl:
            'lib/my_todos/views/my_todos_appointment_request_details/my_todos_appointment_request_details.html',
          controller: 'MyTodosAppointmentRequestDetailsController',
          controllerAs: '$ctrl'
        }
      },
      sticky: true,
      data: {
        viewTitle: 'Appointment Request Details'
      },
      params: {
        topic: undefined
      },
      resolve: {
        previousState: ($state: ng.ui.IStateService) => ({ state: $state.current.name, params: $state.params }),
        pathTaskDetail: (
          loadPathItemCommand: ICommand,
          $stateParams: ng.ui.IStateParamsService,
          $state: ng.ui.IStateService
        ) => loadPathItemCommand($stateParams.eventId, $stateParams.repeatedBy),
        appointmentRequestDetails: (
          $state: ng.ui.IStateService,
          $stateParams: ng.ui.IStateParamsService,
          loadAppointmentRequestCommand: ICommand
        ) => loadAppointmentRequestCommand($stateParams.eventId, $stateParams.repeatedBy)
      }
    })

    // todo placement details route
    .state('my.todos.placement', {
      url: 'placement/:eventId/:repeatedBy',
      views: {
        '@my': {
          templateUrl: 'lib/my_todos/views/my_todos_placement_tests/my_todos_placement_tests.html',
          controller: 'MyTodosPlacementTestsController',
          controllerAs: '$ctrl'
        }
      },
      sticky: true,
      resolve: {
        placementTestScores: (loadPlacementTestScoresCommand: ICommand) => loadPlacementTestScoresCommand(),

        pathTaskDetail: (
          loadPathItemCommand: ICommand,
          $stateParams: ng.ui.IStateParamsService,
          $state: ng.ui.IStateService
        ) => loadPathItemCommand($stateParams.eventId, $stateParams.repeatedBy)
      },
      data: {
        viewTitle: 'Placement Tests'
      }
    })
    .state('my.todos.tip', {
      url: 'tip/:eventId/:repeatedBy',
      views: {
        '@my': {
          templateUrl: 'lib/my_todos/views/my_todo_tip_details/my_todo_tip_details.html',
          controller: 'MyTodoTipDetailController',
          controllerAs: '$ctrl'
        }
      },
      data: {
        viewTitle: 'Tip Detail'
      },
      resolve: {
        pathTipDetail: (
          loadPathItemCommand: ICommand,
          $stateParams: ng.ui.IStateParamsService,
          $state: ng.ui.IStateService
        ) => {
          return loadPathItemCommand($stateParams.eventId, $stateParams.repeatedBy);
        }
      }
    })
    .state('my.todos.reminder', {
      url: 'reminder/:personalTodoID',
      views: {
        '@my': {
          templateUrl: 'lib/my_todos/views/my_todo_reminder_details/my_todo_reminder_details.html',
          controller: 'MyTodoReminderDetailController',
          controllerAs: '$ctrl'
        }
      },
      data: {
        viewTitle: 'Personal To-Do Details'
      },
      sticky: true,
      resolve: {
        pathReminderDetail: (
          loadReminderCommand: ICommand,
          $stateParams: ng.ui.IStateParamsService,
          $state: ng.ui.IStateService
        ) => {
          return loadReminderCommand($stateParams.personalTodoID);
        }
      }
    })
    .state('my.todos.stafftodo', {
      url: 'details/:staffTodoID',
      views: {
        '@my': {
          templateUrl: 'lib/my_todos/views/my_todos_staff_todos_detail/my_todos_staff_todos_detail.html',
          controller: 'MyTodosStaffTodosDetailController',
          controllerAs: '$ctrl'
        }
      },
      data: {
        viewTitle: 'To-Do Detail',
        suppressTrackingPage: true
      },
      params: {
        topic: undefined
      },
      resolve: {
        staffTodoID: ($stateParams: ng.ui.IStateParamsService) => {
          return $stateParams.staffTodoID;
        }
      }
    });
}



// WEBPACK FOOTER //
// ./app/lib/my_todos/todo_routes.ts